import React from 'react';
import {ReactComponent as BackIcon} from '../../assets/daily-back.svg';
import {ReactComponent as RuleIcon} from '../../assets/daily-rule.svg';
import {goBack} from '@utils';
import Rule from '@/common-pages/leaderboard/components/rule';

export default function Header({label}: {label: string}) {
  return (
    <div className="px-3 flex items-center justify-between h-11 text-[#F0DE82]">
      <BackIcon className="size-6" onClick={goBack} />
      <div className="text-base font-bold">{label}</div>
      <div className="flex items-center gap-1">
        <Rule
          gameName="OLD_USER_RANK_ACTIVITY"
          icon={<RuleIcon className="size-5" />}
        />
      </div>
    </div>
  );
}
